import React,{Component} from 'react';
import {PostData} from '../../../service/postData';
import {sendNotification} from '../../../_notificationSettings/notificationPanel';
import validator from 'validator';
import moment from 'moment';

import { MDBDataTableV5 } from 'mdbreact';
let _signingId = '0';
let _businessId = '0';
let _company_id = '0';
let country_code = '0';
let tax_name = '';
let gstTaxDetails = [];

let isOneCheck = false;
let _countryCode = 'IN';
let _UserSession = localStorage.getItem('vs_UserSession');
if(_UserSession!=undefined || _UserSession!=null)
{
    _UserSession = JSON.parse(_UserSession);
    _signingId = _UserSession.loginId;
}

let _companySession = localStorage.getItem('vs_UserCompanySession');
if(_companySession!=undefined || _companySession!=null)
{
    _companySession = JSON.parse(_companySession);
    _businessId = _companySession.business_id;
    _company_id = _companySession.company_id;
    country_code = _companySession.country_code;
    tax_name = _companySession.tax_name;
    gstTaxDetails = _companySession.taxDetails;
}

let columns = [
    {
        label: 'Date',
        field: 'date',
        width: 100,
    },
    {
        label: 'Receipt No',
        field: 'receipt_no',
        width: 100,
    },
    {
        label: 'Amount',
        field: 'amount',
        width: 100,
    }
];

let _loader = 'glb-ldr-prt active';

export default class QuickPaymentHistory extends Component{
    constructor(props){
        super(props);
        this.state = {
            historyData: (this.props.historyData) ? this.props.historyData : [],
            receivedAmount : (this.props.receivedAmount) ? this.props.receivedAmount : '0',
            buttonTitle:'Add New',
            isLoaded : true, 
            itemArray : [],
            errors: {
            }

        }
    }
     

    loadItemListing(){
        let dataList = [];
        let rows = [];
        if(this.state.isLoaded == true)
        {
            let _itemDetails = this.props.historyData;
           
            if(_itemDetails.length > 0){
                
                _itemDetails.map((value,index) => {
                    let displayDate = value.invoice_date;
                    // Format date if it's a valid date string or timestamp
                    if (value.invoice_date) {
                        displayDate = moment(value.invoice_date).isValid()
                            ? moment(value.invoice_date).format('DD/MM/YYYY')
                            : value.invoice_date;
                    }
                    rows.push({
                        date: displayDate,
                        receipt_no: value.invoice_no+ ' (Pymt In)',
                        amount:value.received_amount,
                    });
                });
            }
        }
        
        if (rows) {
            dataList = {
                columns: columns,
                rows: rows
            };
        }       
        return dataList;
    }

    render(){
        if(this.state.isLoaded == true){
            _loader = 'glb-ldr-prt';
        }

        const {errors} = this.state;
        // this.state.receivedAmount is the sale row's DB `received_amount`, which
        // createSalePaymentINRecevTransaction (transactionSaleManage.js:3936-3941)
        // updates on every Receive Payment / Payment-In to
        // `existing_received + this_payment` so the sale's balance/status stays
        // in sync. That cumulative value is wrong for the "Received During Sale"
        // label — the user expects the initial amount they typed while creating
        // the sale, not the running total after subsequent payment-ins.
        // Recover the initial amount by subtracting the linked payment-in
        // amounts already summarised in historyData.
        const _linkedFromHistory = (this.props.historyData || []).reduce(
            (sum, h) => sum + (parseFloat(h.received_amount) || 0),
            0
        );
        // Sale rows now carry the API's receivedDuringSale (common/receivedDuringSale.js), which
        // undoes only Receive Payments: the sale list already sends received_amount net of links,
        // so subtracting again here showed 0, and a Payment-In merely linked to the sale never
        // raised received_amount in the first place. Other callers keep the old derivation.
        const _hasDuringSale = this.props.receivedDuringSale !== undefined && this.props.receivedDuringSale !== null && !isNaN(parseFloat(this.props.receivedDuringSale));
        const _initialReceived = _hasDuringSale
            ? parseFloat(this.props.receivedDuringSale)
            : parseFloat(this.state.receivedAmount || 0) - _linkedFromHistory;
        // Guard tiny floating-point drift so 5 - 4.9999999… doesn't render as
        // a huge number of decimals; also never show negative (bad state).
        const _initialReceivedDisplay = _initialReceived > 0
            ? _initialReceived.toFixed(2)
            : '0.00';
        return(
            <React.Fragment>
                <h2>Received During {this.props.type} : {_initialReceivedDisplay}</h2>

                <div className="block">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="block">
                                <div className="block-content">
                                    <h2 className="block-title ml-10">Linked With : </h2>
                                    
                                </div>
                                <div className="block-content" id="tableData">
                                    <MDBDataTableV5 
                                    hover
                                    entriesOptions={[25, 50, 100]}
                                    entries={25}
                                    pagesAmount={4}
                                    span
                                    pagingTop
                                    searchTop
                                    searchBottom={false}
                                    barReverse
                                    data={this.loadItemListing()}
                                    />
                                </div>
                            </div>
                                
                        </div>
                    </div>
                </div>
                
            </React.Fragment>
        )    
    }
}